module.exports = __webpack_public_path__ + "img/hello-tuts-player-avatar.2b4b8b3f.png";